import React from 'react';
import { motion } from 'framer-motion';
import ScrollReveal from './ScrollReveal';
import '../styles/OurPartnersSection.css';

const partners = [
  {
    id: 1,
    name: 'Partner One',
    link: 'https://mfenterprises.vercel.app/',
    logo: '/assets/images/mfenterprises-logo.png'
  },
  {
    id: 2,
    name: 'Partner Two',
    link: 'https://www.excellenttravels.co.in/',
    logo: '/assets/images/excellent-travels-logo.png'
  },
  {
    id: 3,
    name: 'Partner Three',
    link: 'https://themarveltravels.com/',
    logo: '/assets/images/MTCL-logo.png'
  },
  {
    id: 4,
    name: 'Partner Four',
    link: 'https://www.youtube.com/@Obitostsukuyomi',
    logo: '/assets/images/obito.jpg'
  },
];

const OurPartnersSection = () => {
  // Create a doubled array for seamless looping
  const doubledPartners = [...partners, ...partners];

  return (
    <ScrollReveal>
      <section className="partners-section">
        <div className="partners-content">
          <motion.h2
            className="partners-title"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            Trusted by Industry Leaders
          </motion.h2>
          <motion.p
            className="partners-subtitle"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            We're proud to collaborate with these amazing companies
          </motion.p>

          <motion.div
            className="partners-slider-container"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 0.4 }}
          >
            <div className="partners-slider-wrapper">
              <div className="partners-slider">
                {/* First set of partners */}
                {partners.map((partner) => (
                  <motion.div
                    key={`first-${partner.id}`}
                    className="partner-logo"
                    whileHover={{ y: -5, scale: 1.05 }}
                    transition={{ type: "spring", stiffness: 400, damping: 10 }}
                  >
                    <a
                      href={partner.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="partner-link"
                      aria-label={`Visit ${partner.name} website`}
                    >
                      <img src={partner.logo} alt={partner.name} className="partner-image" />
                    </a>
                  </motion.div>
                ))}

                {/* Second set of partners for seamless loop */}
                {partners.map((partner) => (
                  <motion.div
                    key={`second-${partner.id}`}
                    className="partner-logo"
                    whileHover={{ y: -5, scale: 1.05 }}
                    transition={{ type: "spring", stiffness: 400, damping: 10 }}
                  >
                    <a
                      href={partner.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="partner-link"
                      aria-label={`Visit ${partner.name} website`}
                    >
                      <img src={partner.logo} alt={partner.name} className="partner-image" />
                    </a>
                  </motion.div>
                ))}
              </div>
            </div>
          </motion.div>

          <motion.div
            className="partners-cta"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            <a href="/contact" className="partner-with-us-btn">Become Our Partner</a>
          </motion.div>
        </div>
      </section>
    </ScrollReveal>
  );
};

export default OurPartnersSection;